export default __webpack_public_path__ + "static/media/fevr-bm-icon-7.4668d37c.svg";